import { createIconComponent } from '../../factory/create-icon-component';
export const RectangleMinusIcon = createIconComponent(
  'RectangleMinusIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 12H16M11.6 2H15C15.9288 2 16.3933 2 16.7832 2.05133C19.4756 2.40579 21.5942 4.52444 21.9487 7.21684C22 7.60674 22 8.07116 22 9V9.5V14.5V15C22 15.9288 22 16.3933 21.9487 16.7832C21.5942 19.4756 19.4756 21.5942 16.7832 21.9487C16.3933 22 15.9288 22 15 22H11.6C8.23969 22 6.55953 22 5.27606 21.346C4.14708 20.7708 3.2292 19.8529 2.65396 18.7239C2 17.4405 2 15.7603 2 12.4V11.6C2 8.23969 2 6.55953 2.65396 5.27606C3.2292 4.14708 4.14708 3.2292 5.27606 2.65396C6.55953 2 8.23969 2 11.6 2Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>,
);
